export const styleLabel = {
  color: "var(--emr-text-light)",
  textAlign: "right",
  fontSize: "12px",
};

export const styleInput = {
  border: "solid 1px var(--emr-borderInput)",
  borderRadius: "8px",
  paddingLeft: "10px",
  paddingRight: "10px",
  boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
};

export const universityYear = [
  "1350",
  "1351",
  "1352",
  "1353",
  "1354",
  "1355",
  "1356",
  "1357",
  "1358",
  "1358",
  "1360",
  "1361",
  "1362",
  "1363",
  "1364",
  "1365",
  "1366",
  "1367",
  "1367",
  "1368",
  "1370",
  "1370",
  "1372",
  "1373",
  "1374",
  "1375",
  "1376",
  "1377",
  "1378",
  "1379",
  "1380",
  "1381",
  "1382",
  "1383",
  "1384",
  "1385",
  "1386",
  "1387",
  "1388",
  "1389",
  "1390",
  "1391",
  "1392",
  "1393",
  "1394",
  "1395",
  "1396",
  "1397",
  "1398",
  "1399",
  "1400",
  "1401",
  "1402",
  "1403",
  "1404",
];

export const fields = [
  "پزشکی",
  "دندان پزشکی",
  "روانشناسی",
  "پرستاری",
  "مامایی",
  "فیزیوتراپی",
  "کاردرمانی",
  "داروسازی",
  "اتاق عمل",
  "علوم آزمایشگاهی",
  "بهداشت",
  "تغذیه",
  "همکاری در تیم رسانه",
  "شنوایی سنجی",
  "بینایی سنجی",
  "سایر",
];

export const bloodTypes = [
  { id: "A_PLUS", label: "A+" },
  { id: "A_MINUS", label: "A-" },
  { id: "B_PLUS", label: "B+" },
  { id: "B_MINUS", label: "B-" },
  { id: "AB_PLUS", label: "AB+" },
  { id: "AB_MINUS", label: "AB-" },
  { id: "O_PLUS", label: "O+" },
  { id: "O_MINUS", label: "O-" },
];

export function formatPrice(Number) {
  Number += "";
  Number = Number.replace(",", "");
  const x = Number.split(".");
  let y = x[0];
  const z = x.length > 1 ? "." + x[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(y)) y = y.replace(rgx, "$1" + "," + "$2");
  return y + z;
}
